import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BankAccountService{

  private banks: { label: string, value: string, image?: string }[] = [
    { label: 'Banco do Brasil', value: '001', image: '/assets/img/banks/001_banco-do-brasil.svg' },
    { label: 'Banco da Amazônia', value: '003', image: '/assets/img/banks/003_Banco da Amazonia.svg' },
    { label: 'Banco do Nordeste', value: '004', image: '/assets/img/banks/004_Banco do Nordeste.svg' },
    { label: 'Banco Banestes', value: '021', image: '/assets/img/banks/021_Banco Banestes.svg' },
    { label: 'Santander Brasil', value: '033', image: '/assets/img/banks/033_Santander_Brasil.svg' },
    { label: 'BanPará', value: '037', image: '/assets/img/banks/037_BanPará.svg' },
    { label: 'Banrisul', value: '041', image: '/assets/img/banks/041_Banrisul.svg' },
    { label: 'Banco Inter', value: '077', image: '/assets/img/banks/077_Banco Inter.svg' },
    { label: 'Clear Corretora', value: '102', image: '/assets/img/banks/102_Clear Corretora.svg' },
    { label: 'Caixa Econômica Federal', value: '104', image: '/assets/img/banks/104_Caixa_Econômica_Federal.svg' },
    { label: 'AGI', value: '121', image: '/assets/img/banks/121_AGI.svg' },
    { label: 'Unicred', value: '136', image: '/assets/img/banks/136_Unicred.svg' },
    { label: 'Itaú BBA', value: '184', image: '/assets/img/banks/184_Itaú BBA.svg' },
    { label: 'Banco BRB', value: '208', image: '/assets/img/banks/208_Banco BRB.svg' },
    { label: 'Original', value: '212', image: '/assets/img/banks/212_Original.svg' },
    { label: 'Fibra', value: '224', image: '/assets/img/banks/224_Fibra.svg' },
    { label: 'Bradesco', value: '237', image: '/assets/img/banks/237_Bradesco.svg' },
    { label: 'Nubank', value: '260', image: '/assets/img/banks/260_Nubank.svg' },
    { label: 'Pagbank', value: '290', image: '/assets/img/banks/290_Pagbank.svg' },
    { label: 'MercadoPago', value: '323', image: '/assets/img/banks/323_MercadoPago.svg' },
    { label: 'C6 Bank', value: '336', image: '/assets/img/banks/336_C6_Bank.svg' },
    { label: 'Itaú Unibanco', value: '341', image: '/assets/img/banks/341_Itaú_Unibanco.svg' },
    { label: 'Rico', value: '348', image: '/assets/img/banks/348_Rico.svg' },
    { label: 'JP Morgan', value: '376', image: '/assets/img/banks/376_JP Morgan.svg' },
    { label: 'Cora', value: '403', image: '/assets/img/banks/403_Cora.svg' },
    { label: 'Safra', value: '422', image: '/assets/img/banks/422_Safra.svg' },
    { label: 'Banco Pan', value: '623', image: '/assets/img/banks/623_Banco Pan.svg' },
    { label: 'Sofisa', value: '637', image: '/assets/img/banks/637_Sofisa.svg' },
    { label: 'Banco BV', value: '655', image: '/assets/img/banks/655_Banco_BV.svg' },
    { label: 'Daycoval', value: '707', image: '/assets/img/banks/707_Daycoval.svg' },
    { label: 'Citibank', value: '745', image: '/assets/img/banks/745_Citibank.svg' },
    { label: 'Sicredi', value: '748', image: '/assets/img/banks/748_Sicredi.svg' },
    { label: 'Sicoob', value: '756', image: '/assets/img/banks/756_Sicoob.svg' },
    { label: 'Banco 999', value: '999', image: '/assets/img/banks/999_Banco999.svg' }
  ];

  public getBanks(): { label: string, value: string, image?: string }[] {
    return this.banks;
  }

  public getBankByValue(value: string): { label: string, value: string, image?: string } | undefined {
    return this.banks.find(bank => bank.value === value);
  }
}